module.exports = __webpack_public_path__ + "img/r1.92f339dd.jpg";